import Box from '@mui/material/Box'
import RequestsFromApp from '../TableOfRequests/RequestsFromApp/RequestsFromApp'
import MultipleChoice from '../MultipleChoice/MultipleChoice'
import { useState, useEffect } from 'react'
import { OperatorsSubListI } from '../../interfaces/filters'
import { useAppSelector, useAppDispatch } from '../../hooks/hooks'
import { checkAuth, decodeToken } from '../../services/autorization'
import './MainTab.scss'


const MainTab = () => {

  const { role } = useAppSelector((state) => state.user)
  const [selectedAppeals, setSelectedAppeals] = useState<{ [key: string]: boolean }>({})               // состояние выбранных обращений
  const [listSubUsers, setListSubUsers] = useState<OperatorsSubListI[]>([])                           // список операторов
  const [appealsIds, setAppealsIds] = useState<string[]>([])
  const [userId, setUserId] = useState<string>('')
  const dispatch = useAppDispatch()

  const handleChangeCheckBox = (id: string, checked: boolean) => {
    setSelectedAppeals(prev => ({ ...prev, [id]: checked }))
  }

  useEffect(() => {
    const selectedIds = Object.entries(selectedAppeals)   //  свойство Object.entries превращает объект в массив пар [id, checked]
      .filter(([_, checked]) => checked)
      .map(([id]) => id)
    setAppealsIds(selectedIds)

    // localStorage.setItem('selectedAppealsIds', JSON.stringify(selectedIds))
  }, [selectedAppeals])

  const clearSelectedAppeals = () => setSelectedAppeals({})                                 // Функция для сброса выбранных чекбоксов после назначения

  useEffect(() => {
    if (localStorage.getItem('dataPortal')) {
      //@ts-ignore
      const token = JSON.parse(localStorage.getItem('dataPortal')).token;
      const id = decodeToken(token);
      console.log(id)
      setUserId(id.id)
      dispatch(checkAuth({ ...id, token }));
    }
  }, []);


  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        {userId === '95' && (
          <MultipleChoice 
            selectedAppeals={selectedAppeals}
            clearSelectedAppeals={clearSelectedAppeals}
            listSubUsers={listSubUsers}
          />
        )}
        <div className="table">
          <div className="table__block">
            {/* <svg style={{width: 15, height: 15}} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"/></svg> */}
          </div>
          <div className="table__block">Номер</div>
          <div className="table__block">Дата регистрации</div>
          <div className="table__block">Дата окончания</div>
          <div className="table__block">Тема обращения</div>
          <div className="table__block">Исполнитель</div>
          <div className="table__block">Статус</div>
          <div className="table__block">Текст обращения</div>
        </div>
      </Box>
      <RequestsFromApp 
        selectedAppeals={selectedAppeals} 
        onCheckBoxChange={handleChangeCheckBox}
        setListSubUsers={setListSubUsers}
      />
    </Box>
  )
}
export default MainTab